export const FEES_5611 = [{ to: 1697896947, feeUsd: '10.61' }]
